export default {
  primary: '#0C64E9',
  secondary: '#031A3A',
  accent: '#61d1ff',
  error: '#b00000',
  info: '#00A0DC',
  success: '#37A996',
  warning: '#F07D0F',
  anchor: '#0C64E9'
}
